/**
 * 错误日志接口
 **/
import { Injectable } from '@angular/core';
import { SwHttpClientService } from 'src/app/librarys/serves/sw-http-client.service';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class LoginStatisticService {
   //基础平台微服务api
   prefix: string = environment.seekerWebAPI;


   constructor(
     private http: SwHttpClientService,
   ) {
   }

  //#region 日志统计接口
  /**
   * 登录次数统计
   *
   * @param param
   * @returns {Observable<any>}
   */
  statLoginCount(startTime, endTime,systemId) {
    const url = this.prefix + 'loginLog/statByLoginCount?startTime=' + startTime + "&endTime=" + endTime+"&systemId="+systemId;
    return this.http.Post(url, null);
  }

  /**
   * 登录时长统计
   * @param param
   * @returns {Observable<any>}
   */
  statLoginTime(startTime, endTime) {
    const url = this.prefix + 'loginLog/statByLoginTime?startTime=' + startTime + "&endTime=" + endTime;
    return this.http.Post(url, null);
  }

  /**
   * 登录渠道统计
   * @param param
   * @returns {Observable<any>}
   */
  statLoginChannel(startTime, endTime) {
    const url = this.prefix + 'loginLog/statByLoginChannel?startTime=' + startTime + "&endTime=" + endTime;
    return this.http.Post(url, null);
  }

  //#endregion


}
